import { render, staticRenderFns } from "./ChargerSuggestionPopup.vue?vue&type=template&id=054a32ea&"
import script from "./ChargerSuggestionPopup.vue?vue&type=script&lang=js&"
export * from "./ChargerSuggestionPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChargerSuggestionPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports